const CSRF_COOKIE_NAME = 'fjb-csrf';
export const CSRF_HEADER_NAME = 'X-CSRF-Token';
const MULTIPART_ENHANCED_ATTRIBUTE = 'data-fj-csrf-multipart-enhanced';

function cookieToken(): string | null {
    const values: string[] = [];
    document.cookie.split(';').forEach((part) => {
        const [name, ...rawValue] = part.trim().split('=');
        if (name !== CSRF_COOKIE_NAME) return;
        try {
            values.push(decodeURIComponent(rawValue.join('=')));
        } catch {
            values.push('');
        }
    });
    return values.length === 1 && values[0] ? values[0] : null;
}

export function csrfToken(root: ParentNode = document): string | null {
    const rendered = root.querySelector<HTMLInputElement>('input[name="_csrf"]')?.value.trim()
        ?? document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content.trim()
        ?? '';
    return rendered || cookieToken();
}

export function csrfHeader(root: ParentNode = document): Record<string, string> {
    const token = csrfToken(root);
    if (!token) {
        throw new Error('CSRF token is unavailable.');
    }
    return { [CSRF_HEADER_NAME]: token };
}

export function enhanceCsrfMultipartForms(root: ParentNode = document): void {
    root.querySelectorAll<HTMLFormElement>('form[method="post"][enctype="multipart/form-data"]').forEach((form) => {
        if (form.hasAttribute(MULTIPART_ENHANCED_ATTRIBUTE)) return;
        if (form.hasAttribute('data-fj-guest-application-form') && !csrfToken(form)) return;
        form.setAttribute(MULTIPART_ENHANCED_ATTRIBUTE, 'true');
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (form.getAttribute('aria-busy') === 'true') return;

            try {
                const body = new FormData(form, event.submitter);
                body.delete('_csrf');
                form.setAttribute('aria-busy', 'true');
                const response = await fetch(form.action, {
                    method: 'POST',
                    body,
                    credentials: 'same-origin',
                    headers: csrfHeader(form),
                    redirect: 'follow',
                });
                if (response.redirected) {
                    window.location.assign(response.url);
                    return;
                }
                const html = await response.text();
                document.open();
                document.addEventListener('DOMContentLoaded', () => {
                    enhanceCsrfMultipartForms(document);
                }, { once: true });
                document.write(html);
                document.close();
            } catch {
                form.removeAttribute('aria-busy');
                const notice = document.createElement('p');
                notice.className = 'alert alert-danger';
                notice.setAttribute('role', 'alert');
                notice.textContent = 'The upload could not be submitted. Refresh the page and try again.';
                form.prepend(notice);
            }
        });
    });
}
